import { resolveLabel } from '../renderer/labelResolver';
/**
 * The tabs the tab bar shows (CZNA-321): `visibleTabIds` narrows them; an id the config
 * does not carry is ignored, and when none match every tab is shown rather than none.
 */
export var shownTabs = function (config, visibleTabIds) {
    var narrowed = visibleTabIds
        ? config.tabs.filter(function (tab) { return visibleTabIds.includes(tab.id); })
        : config.tabs;
    return narrowed.length > 0 ? narrowed : config.tabs;
};
/**
 * The first tab carrying a field with `tag`, with its index among `tabs`; `null` when none does.
 *
 * `ambiguous` is true when the form reaches the tag through several field definitions
 * (`024-isni`, `024-viaf`, … are all `024`). An issue carries only the tag and the record's
 * occurrence of it, which says nothing about which of them it is — so `field` is then just
 * the first one, and neither its name nor an occurrence index may be trusted.
 */
export var locateField = function (tabs, tag) {
    if (!tag)
        return null;
    for (var tabIndex = 0; tabIndex < tabs.length; tabIndex++) {
        var field = tabs[tabIndex].fields.find(function (fd) { return fd.tag === tag; });
        if (field) {
            var variants = tabs.reduce(function (n, t) { return n + t.fields.filter(function (fd) { return fd.tag === tag; }).length; }, 0);
            return { tab: tabs[tabIndex], tabIndex: tabIndex, field: field, ambiguous: variants > 1 };
        }
    }
    return null;
};
/**
 * A field the way the form names it — its name and the tab it sits on — for an issue list
 * (`ValidationIssueList#describeLocation`); `null` for a tag the form does not show.
 */
export var describeFieldLocation = function (tabs, intl) { return function (location) {
    var found = locateField(tabs, location.tag);
    return found
        ? {
            // Several definitions share the tag (ISNI, VIAF, … on 024): name none rather than the wrong one.
            fieldLabel: found.ambiguous ? undefined : resolveLabel(found.field, intl),
            tabLabel: resolveLabel(found.tab, intl),
            tabIndex: found.tabIndex,
        }
        : null;
}; };
var locationsOf = function (issue) { return (issue.locations && issue.locations.length > 0 ? issue.locations : [issue.location]); };
/** How many issues point at a field on `tab` — each issue once, however many of its locations do. */
export var countIssuesOnTab = function (tabs, tab, issues) { return (issues !== null && issues !== void 0 ? issues : []).filter(function (issue) { return locationsOf(issue).some(function (loc) { var _a; return ((_a = locateField(tabs, loc === null || loc === void 0 ? void 0 : loc.tag)) === null || _a === void 0 ? void 0 : _a.tab) === tab; }); }).length; };
